import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Event } from "../../../../../models/event";
import { EventType } from "../../../../../models/event-type";
import { PrintDocument } from "../../../../../models/print-document";
import { Role } from "../../../../../models/role";
import { RoleRegistration } from "../../../../../models/role-registration";
import { RoleStatus } from "../../../../../models/role-status";
import { FormControllerService } from "../../../../../services/form-controller/form-controller.service";
import { PrintDocumentControllerService } from "../../../../../services/print-document/print-document-controller.service";
import { RoleControllerService } from "../../../../../services/role-controller/role-controller.service";
import { RoleService } from "../../../../../services/role-controller/role.service";
import { Store } from "../../../../../services/store.service";
import { TranslatedBaseError } from "../../../TranslatedBaseError";
import { TranslateService } from "@ngx-translate/core";
import { Institution } from "../../../../../models/institution";
import { RoleInstitution } from "../../../../../models/role-institution";
import {
  RoleInstitutionControllerService,
} from "../../../../../services/role-controller/role-institution-controller.service";
import { RecoverOrphanConfig } from "../../../../../models/recover-orphan-config";

@Component({
  selector: "role-manage",
  templateUrl: "./role-manage.component.html",
  providers: [RoleControllerService, FormControllerService, ToastrService, PrintDocumentControllerService],
})
export class RoleManageComponent extends TranslatedBaseError implements OnChanges {

  @Input() public role = new Role();
  @Input() public serviceId: string;
  @Input() public showRoleAdd: boolean;
  @Input() public determinantMapById: { [key: string]: string };
  @Input() public institutions: Institution[];
  @Input() public roleInstitutions: RoleInstitution[];
  @Input() public debugErrors: RecoverOrphanConfig[] = [];

  @Output() public modalAddedEvent = new EventEmitter();
  @Output() public changedData = new EventEmitter();
  @Output() public updatedRole = new EventEmitter();
  // emit for botType and category
  @Output() public changeBotType = new EventEmitter();
  @Output() public changeBotCategory = new EventEmitter();
  @Output() public selectInstitution = new EventEmitter();

  public serviceRoles: Role[];
  public statuses: RoleStatus[];
  public printDocuments: PrintDocument[];
  public roleId: string;
  public registrations: RoleRegistration[];
  public roleInstitutionsLength: number = -1;
  public roleUnitsLength: number = 0;

  public showDeterminant: boolean = false;
  public initialValue: string = "";
  public roleShortName: string = "";

  public newRole: any;

  public loading: boolean = false;
  public doNotReload: boolean = true;

  constructor(private roleController: RoleControllerService,
    private roleService: RoleService,
    private printDocController: PrintDocumentControllerService,
    private router: Router,
    public store: Store,
    toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (this.role && !this.role.id && !this.doNotReload && !this.loading) {
      this.reloadRole();
      this.getServiceRolesList();
    } else if (this.role && !this.doNotReload && !this.loading) {
      this.reloadRole();
    } else {
      console.log(this.role);
      // this.loading = false;
      this.registrations = this.role?.registrations;
      // this.doNotReload = false;
    }
    if (this.loading) {
      this.loading = !this.loading;
    }
    this.printDocController.getDocumentList(this.serviceId, true).subscribe(
      (data) => {
        this.printDocuments = data;
      },
    );
    if (changes.roleInstitutions) {
      this.roleInstitutionsLength = changes.roleInstitutions.currentValue.length;
    }
  }

  public setInsitution(e) {
    this.selectInstitution.emit(e);
  }

  public notifyRoleChange() {
    this.updatedRole.emit();
  }

  public addNewRole() {
    this.loading = true;
    this.role.name = this.role.name.trim().replace(/[^\p{L}\p{N}_ ()-]/gu, "");
    this.role.shortName = this.role.shortName.trim().replace(/[^\p{L}\p{N}_ ()-]/gu, "");
    if (this.role.type === "UserRole") {
      this.roleController.createUserRole(this.serviceId, this.role).subscribe(
        (data) => {
          this.newRole = data;
          this.modalAddedEvent.emit(new Event(null, EventType.Add));
          this.responseSuccessful("User role created!");
          this.loading = false;
        },
        (error) => {
          this.showErrorMessage(error);
          this.loading = false;
        },
      );
    } else if (this.role.type === "BotRole") {
      this.roleController.createBotRole(this.serviceId, this.role).subscribe(
        (data) => {
          this.newRole = data;
          this.responseSuccessful("Bot role created!");
          this.modalAddedEvent.emit(new Event(null, EventType.Add));
          this.loading = false;
        },
        (error) => {
          this.showErrorMessage(error);
          this.loading = false;
        },
      );
    } else {
      this.showErrorMessageWithTitle("Validation error!", "Role type not selected!");
    }
  }

  public saveRole() {
    console.log("saving role");
    if (this.role && this.role.id &&
      this.role.repeatUntilSuccessful &&
      ((!this.role.repeatInMinutes &&
        !this.role.repeatInHours &&
        !this.role.repeatInDays) ||
        (!this.role.durationInMinutes &&
          !this.role.durationInHours &&
          !this.role.durationInDays))) {
      console.log("error");
      this.error("Please indicate polling intervals and periods", "Wait!");
    } else {
      if (this.role && this.role.id) {
        this.loading = true;
        this.role.name = this.role.name.trim().replace(/[^\p{L}\p{N}_ ()-]/gu, "");
        this.role.shortName = this.role.shortName.trim().replace(/[^\p{L}\p{N}_ ()-]/gu, "");
        if (this.role.type === "UserRole") {
          this.roleController.saveUserRole(this.role).subscribe(
            (data) => {
              this.responseSuccessful("User role saved!");
              this.roleService.changeMade();
              this.changedData.emit(this.role);
            },
            (error) => {
              this.showErrorMessageWithTitle("Role saving error!", error);
              this.loading = false;
            },
          );
        } else if (this.role.type === "BotRole") {
          this.roleController.saveBotRole(this.role).subscribe(
            (data) => {
              console.log("saved role");
              this.responseSuccessful("BOT role saved!");
              this.roleService.changeMade();
              this.changedData.emit(this.role);
            },
            (error) => {
              this.showErrorMessageWithTitle("Role saving error!", error);
              this.loading = false;
            },
          );
        } else {
          this.showErrorMessageWithTitle("Validation error!", "Role type not selected!");
          this.loading = false;
        }
      }
    }
  }

  public deleteRole(isConfirmed) {
    if (isConfirmed) {
      this.roleController.deleteRole(this.role.id).subscribe(
        (data) => {
          this.responseSuccessful("Role deleted!");
          this.router.navigate(["/services/" + this.serviceId + "/roles"]);
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public reloadRole() {
    this.loading = true;
    if (this.role?.id) {
      console.log("--- reloadRole --- reloading role");
      this.roleController.getRole(this.role?.id).subscribe(
        (data) => {
          console.log("--- reloadRole --- reloaded role", data);
          this.uploadData(data);
          this.loading = false;
        },
      );
    } else {
      this.loading = false;
    }
  }

  public uploadData(role: Role) {
    this.role = role;
    this.statuses = this.sortStatusesByNumber(role.statuses);
    this.registrations = this.role.registrations;
    if (this.role.bot) {
      this.role.botType = this.role.bot.botType;
      this.role.category = this.role.bot.category;
    }
    this.doNotReload = true;
  }

  public getServiceRolesList() {
    this.roleController.getRolesList(this.serviceId, false).subscribe(
      (data) => this.serviceRoles = data,
    );
  }

  public sortStatusesByNumber(statuses) {
    return statuses.sort((a, b) => {
      const textA = a.sortNumber;
      const textB = b.sortNumber;
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }

  public hasDeterminant(item) {
    if (!item.jsonDeterminants || item.jsonDeterminants === "[{\"type\":\"OR\",\"items\":[]}]") {
      return false;
    }
    return true;
  }

  public hasError(itemId: string): boolean {
    if (!this.debugErrors || !this.debugErrors.length || !itemId) { return false; }
    return this.debugErrors.some(error => itemId.includes(error.conflictingValue));
  }

  public removeDeterminant() {
    this.role.jsonDeterminants = null;
    this.showDeterminant = !this.showDeterminant;
    this.changedData.emit(this.role);
  }

  public startEdit(event) {
    this.initialValue = event.target.value;
  }

  public submitEditOnFocus(event) {
    const value = event.target.value;
    if (value) {
      // Check if value has changed
      if (event.target.value !== this.initialValue) {
        this.initialValue = "";
        this.saveRole();
      }
    }
  }

  public submitEmptyEditOnFocus(event) {
    if (event.target.value !== this.initialValue) {
      this.initialValue = "";
      this.saveRole();
    }
  }

  public updateRoleInstitutionsLength(event) {
    this.roleInstitutionsLength = event.roleInstitutionsLength;
  }

  public updateRoleUnitsLength(event) {
    this.roleUnitsLength = event.roleUnitsLength;
  }

  public openDetEdit() {
    this.hideLines();
    this.store.state.common.sections.active = true;
    this.store.state.common.sections.type = "determinant";
  }

  public isForApplicant() {
    if (this.role) {
      return this.role.assignedTo === "applicant" || this.role.assignedTo === "applicantPayment";
    }
    return false;
  }

  public nameChanged(value): void {
    this.roleShortName = value;
    this.role.shortName = this.roleShortName.substring(0, 20);
  }

  public hideLines(): void {
    document.querySelectorAll(".flow-line").forEach((l) => {
      l.classList.add("overlap");
    });
  }

  public showLines(): void {
    document.querySelectorAll(".flow-line").forEach((l) => {
      l.classList.remove("overlap");
    });
  }

}
